module.exports = __webpack_public_path__ + "img/avatar1.c5e0b1eb.png";